import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'

// 引入样式
import 'swiper/css/swiper.css'

Vue.prototype.$baseUrl = 'https://sensor.hrbyc.top/'
Vue.prototype.$imgUrl = 'https://sensor.hrbyc.top/'

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI);
new Vue({
    router,
    render: h => h(App),
}).$mount("#app");
